export default (state = [], action = {}) => {
  switch(action.type) {
    case 'FETCH_DEFAULT_TODOLISTS':
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/todolistsDefault.js